import { BooksServiceClient } from "@sms/journal-books-journal-books-api-client-ts";

export const getBook = (id: number) => {
  const service = new BooksServiceClient();
  return service.GetBook(id);
};

export const deleteBook = (id: number) => {
  const service = new BooksServiceClient();
  return service.DeleteBook(id);
};
